import { useEffect, useState } from 'react';

import useUserStore from '@lcsc-ui/store/user';
import indexBuriedPoint from '@lcsc-ui/utils/_indexBuriedPoint';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';
import dynamic from 'next/dynamic';

const DynamicIndexMyApplicationComponent = dynamic(() => import('./IndexMyApplication'));

const IndexMainRight = ({ data }) => {
  const [userInfoData, setUserInfoData] = useState(null);
  const [newUserAndPlusInfoData, setNewUserAndPlusInfoData] = useState(null);
  const { userInfo } = useUserStore();

  // 跳登录和注册
  async function gotoLogin(e, type) {
    buriedPoint({
      cp: 'index',
      ty: 'click',
      op: type,
      data: {
        hf: type === 'LOGIN' ? '/login.html' : '/home/register.html',
      },
    });
  }

  useEffect(() => {
    if (userInfo?.customerLogin === 1) {
      getUserMsg(); // 获取用户信息
    }
    getNewUserAndPlusInfoData();
  }, [userInfo]);

  function getNewUserAndPlusInfoData() {
    sendAxios({
      method: 'get',
      url: `/get/new/user/and/plus/info`,
      baseURL: Domains.lcscActivityUrl,
    }).then((res) => {
      if (res.code === 200) {
        setNewUserAndPlusInfoData(res.result);
      }
    });
  }
  function getUserMsg() {
    sendAxios({
      method: 'get',
      url: `/async/page/home/order/customer/message`,
      baseURL: Domains.lcscOrderUrl,
    }).then((res) => {
      if (res.code === 200) {
        setUserInfoData(res.result);
      }
    });
  }

  if (data) {
    const { mallNoticeList } = data;
    const lcscWwwUrl = Domains.lcscWwwUrl;
    const newsTypeClassMap = {
      new: 'bg-[#E3F5FF] text-[#0093E6]',
      hot: 'bg-[#FEEBE9] text-[#FF4D4F]',
    };

    const NewCustomerCard = ({ data }) => {
      const { isLogin, isNewUser, isPlus, newUserCouponAmount } = data;
      let topText;
      let centerText;
      let bottomText;
      let href = Domains.lcscActivityUrl + '/newuser.html';
      if (!isLogin || (isLogin && isNewUser)) {
        // 未登录
        topText = '新人福利';
        centerText = newUserCouponAmount + '元大礼包';
        bottomText = isLogin ? '查看全部' : '马上领取';
      }
      if (isLogin && !isNewUser && isPlus) {
        // 已登录
        topText = '邀请有礼';
        centerText = '奖励不封顶';
        bottomText = '多邀多得';
        href = Domains.lcscActivityUrl + '/invite/info.html';
      }
      if (!topText) {
        return <></>;
      }
      function handleClickNewCusCard() {
        if (isLogin && !isNewUser && isPlus) {
          indexBuriedPoint('Invitation_with_Gifts', href); // 邀请有礼埋点
        } else if (!isLogin) {
          indexBuriedPoint('new_welfare', href); // 未登录新人福利埋点
        }
      }
      return (
        <a
          href={href}
          target="_blank"
          title={topText}
          onClick={handleClickNewCusCard}
          data-spm={isNewUser ? 'xr' : 'yq'}
        >
          <div className="mr-[10px] w-[108px] h-[88px] py-[10px] pl-[10px] rounded-[10px] shadow-[inset -2px 2px 6px 0px #FFAFAF] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/invitation-gifts-2.png)]">
            <p className="text-[13px] h-[19px] leading-[19px] font-bold text-[#8F0000] mb-[3px]">{topText}</p>
            <p className="text-[#E66466] h-[16px] text-[12px] leading-[16px] mb-[9px]">{centerText}</p>
            <p className="flex items-center text-[10px] text-[#8F0000] h-[14px] leading-[14px]">
              <span>{bottomText}</span>
              <img
                className="ml-[3px]"
                src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/invitation-gifts-arrow.svg"
              />
            </p>
          </div>
        </a>
      );
    };
    const PlusInfoCard = ({ data }) => {
      const { isLogin, isNewUser, isPlus, freightCount, productCount } = data;
      let centerTextDom = (
        <>
          <p className="mt-[2px] leading-[16px] h-[16px] mb-[6px] text-[#C5A232]">尊享8大权益</p>
          <p className="flex items-center mt-[6px] text-[10px] text-[#81521F] h-[14px] leading-[14px]">
            <span>立即开通</span>
            <img
              className="ml-[3px] size-[7px]"
              src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-arrow.svg"
            />
          </p>
        </>
      );
      if (isLogin && isPlus) {
        centerTextDom = (
          <div className="flex justify-between text-[12px]">
            <div className="text-[#A88100]">
              <p className="leading-[16px] mb-[5px]">运费券</p>
              <p className="text-[#81521F] text-center leading-[19px]">{freightCount || 0}</p>
            </div>
            <div className="text-[#A88100]">
              <p className="leading-[16px] mb-[5px]">商品券</p>
              <p className="text-[#81521F] text-center leading-[19px]">{productCount || 0}</p>
            </div>
          </div>
        );
      }
      let content = (
        <div className="w-[108px] h-[88px] rounded-[10px] p-[10px] shadow-[inset -2px 2px 6px 0px #FFAFAF] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-card-2.png)]">
          <p className="m-0 block text-[13px] font-bold h-[19px] leading-[19px] mb-[3px] text-[#81521F]">PLUS会员</p>
          {centerTextDom}
        </div>
      );

      function handleClickPlusCard() {
        if (!isLogin) {
          buriedPoint({
            cp: 'index',
            ty: 'click',
            op: 'plus_1',
            data: {
              hf: Domains.lcscActivityUrl + '/plusIndex.html',
            },
          });
        }
      }
      if (isLogin && !isPlus && !isNewUser) {
        content = (
          <div className="w-[226px] h-[89px] rounded-[10px] px-[8px] py-[10px] shadow-[inset -2px 2px 6px 0px #FFAFAF] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-big-bg-2.png)] bg-cover">
            <p className="text-[12px] text-[#81521F] flex justify-between items-center">
              <span>PLUS会员专属8大超值权益</span>
              <a href={Domains.lcscActivityUrl + '/plusIndex.html'} target="_blank" className="text-[10px]">
                全部权益&gt;
              </a>
            </p>
            <div className="flex items-center justify-between mt-[10px] text-[#81521F]">
              <div className="flex flex-col items-center">
                <span className="inline-block rounded-[50%] size-[20px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-big-bg-yf-coupon.svg)] mb-[4px]"></span>
                <span>运费券</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="inline-block rounded-[50%] size-[20px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-big-bg-coupon.svg)] mb-[4px]"></span>
                <span>优惠券</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="inline-block rounded-[50%] size-[20px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-big-bg-brand-coupon.svg)] mb-[4px]"></span>
                <span>品牌券</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="inline-block rounded-[50%] size-[20px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-big-bg-point.svg)] mb-[4px]"></span>
                <span>1.3倍积分</span>
              </div>
            </div>
          </div>
        );
      }
      return (
        <a
          href={Domains.lcscActivityUrl + '/plusIndex.html'}
          target="_blank"
          title="PLUS会员"
          onClick={handleClickPlusCard}
          data-spm="hy"
        >
          {content}
        </a>
      );
    };

    const integralTips = userInfoData?.integral ? `${userInfoData.integral}年度成长值，每月1号更新` : '';
    let userInfoDom;

    if (userInfoData) {
      userInfoDom = <span>客编{userInfoData.customerCode}</span>;
    } else {
      userInfoDom = (
        <div className="flex items-center">
          <img
            className="size-[44px] rounded-[50%] mr-[6px]"
            src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/avatar_header-2.svg"
            alt="头像"
          />
          <div className="text-[#54657D] mt-[4px]">
            <p>Hi~ 欢迎来到立创商城！</p>
            <a
              target="_blank"
              id="login"
              href="/login.html"
              rel="nofollow"
              aria-label="登录立创"
              className="hover:text-lcBlue"
              onClick={(e) => {
                gotoLogin(e, 'LOGIN');
              }}
            >
              <span className="font-bold">登录</span>
            </a>
            <span className="mx-[8px] text-[#6C6C6C]">|</span>
            <a
              id="register"
              target="_blank"
              href={Domains.lcscMemberUrl + '/home/register.html'}
              rel="nofollow"
              aria-label="注册立创"
              className="mr-[16px] hover:text-lcBlue"
              onClick={(e) => {
                gotoLogin(e, 'REGISTER');
              }}
            >
              <span className="font-bold">注册</span>
            </a>
          </div>
        </div>
      );
    }

    return (
      <div className="w-[246px]">
        <div
          id="user-info"
          className="bg-[#F5F5F5] bg-gradient-to-b from-[#f5f5f5] to-[#f9f9f9] px-[10px] pt-[10px] rounded-[10px] pb-[15px] h-[175px]"
          data-spm="mb"
        >
          <div>
            <div className="flex mb-[4px] leading-[23px]">
              <div className="text-black text-[14px] mr-[10px]">{userInfoDom}</div>
              {userInfoData && (
                <>
                  {userInfoData?.isPlus && (
                    <img
                      className="mr-[6px]"
                      src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/plus-flag.svg"
                      alt="plus图标"
                    />
                  )}
                  {userInfoData?.integralLeval === '注册会员' && (
                    <img
                      src="https://static.szlcsc.com/ecp/assets/web/common/images/userinfo/lv1.svg"
                      alt="注册会员"
                      title={integralTips || '注册会员'}
                    />
                  )}
                  {userInfoData?.integralLeval === '铜牌会员' && (
                    <img
                      src="https://static.szlcsc.com/ecp/assets/web/common/images/userinfo/lv2.svg"
                      alt="铜牌会员"
                      title={integralTips || '铜牌会员'}
                    />
                  )}
                  {userInfoData?.integralLeval === '银牌会员' && (
                    <img
                      src="https://static.szlcsc.com/ecp/assets/web/common/images/userinfo/lv3.svg"
                      alt="银牌会员"
                      title={integralTips || '银牌会员'}
                    />
                  )}
                  {userInfoData?.integralLeval === '金牌会员' && (
                    <img
                      src="https://static.szlcsc.com/ecp/assets/web/common/images/userinfo/lv4.svg"
                      alt="金牌会员"
                      title={integralTips || '金牌会员'}
                    />
                  )}
                  {userInfoData?.integralLeval === '钻石会员' && (
                    <img
                      src="https://static.szlcsc.com/ecp/assets/web/common/images/userinfo/lv5.svg"
                      alt="钻石会员"
                      title={integralTips || '钻石会员'}
                    />
                  )}
                  {userInfoData?.integralLeval === '皇冠会员' && (
                    <img
                      src="https://static.szlcsc.com/ecp/assets/web/common/images/userinfo/lv6.svg"
                      alt="皇冠会员"
                      title={integralTips || '皇冠会员'}
                    />
                  )}
                </>
              )}
            </div>
            {userInfoData?.pointRate && (
              <span className="inline-block px-[5px] text-white leading-[18px] h-[18px] bg-[#7a7a7a] rounded-[9px] rounded-tl-none">
                {userInfoData.pointRate}倍积分提速中
              </span>
            )}
          </div>
          <div className="flex justify-between mt-[12px]">
            {newUserAndPlusInfoData && (
              <>
                <NewCustomerCard data={newUserAndPlusInfoData} />
                <PlusInfoCard data={newUserAndPlusInfoData} />
              </>
            )}
          </div>
        </div>
        <div id="news-area" data-spm="gg" className="py-[15px] max-h-[144px] border-b border-solid border-[#F0F0F0]">
          <div className="flex justify-between items-center">
            <h3 className="text-[14px] text-black font-bold leading-[19px] m-0">立创公告</h3>
            <a
              href={`${lcscWwwUrl}/news/list.html`}
              title="更多公告"
              target="_blank"
              className="text-[#56657F] leading-[16px] hover:text-lcBlue"
              onClick={() => buriedPoint({ cp: 'index', ty: 'click', op: 'announcement' })}
              data-spm="mr"
            >
              更多
            </a>
          </div>
          <ul className="mt-[11px] mb-0">
            {mallNoticeList.slice(0, 3).map((mallNotice, idx) => (
              <li
                key={idx}
                className={`max-w-[243px] h-[18px] leading-[18px] truncate ${idx === 2 ? 'mb-0' : 'mb-[7px]'}`}
              >
                <span
                  className={`${idx === 2 ? newsTypeClassMap.new : newsTypeClassMap.hot} w-[37px] inline-block rounded-[8px] text-center mr-[6px]`}
                >
                  {idx === 2 ? '最新' : '热门'}
                </span>
                <a
                  href={`${lcscWwwUrl}/news/${mallNotice.informationId}.html`}
                  className="text-black hover:text-lcBlue"
                  title={mallNotice.title}
                  target="_blank"
                  data-spm={idx + 1}
                >
                  {mallNotice.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <DynamicIndexMyApplicationComponent />
      </div>
    );
  }
};

export default IndexMainRight;
